import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  // Stagger sequence
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.15,
      },
    },
  };

  // Ultra-smooth center-outward expanding text reveal
  const smoothCenterReveal = {
    hidden: {
      clipPath: 'polygon(50% 0%, 50% 0%, 50% 100%, 50% 100%)',
      opacity: 0,
      filter: 'blur(4px)',
    },
    visible: {
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      opacity: 1,
      filter: 'blur(0px)',
      transition: {
        duration: 1.25,
        ease: [0.22, 1, 0.36, 1], // Smooth cinematic ease-out
      },
    },
  };

  // Smooth button entry
  const buttonVariants = {
    hidden: { opacity: 0, y: 25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section className="consulox-hero">
      {/* Background Architectural Columns Overlay */}
      <div className="hero-bg-architecture" />

      <div className="hero-inner-wrapper">
        {/* Left Column: Smooth Center-Outward Text Reveal */}
        <motion.div
          className="hero-content-left"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <h1 className="hero-main-title">
            <motion.span variants={smoothCenterReveal} className="reveal-line">
              Your Child Doesn't
            </motion.span>
            <motion.span variants={smoothCenterReveal} className="reveal-line">
              Need More Advice.
            </motion.span>
            <motion.span variants={smoothCenterReveal} className="reveal-line">
              They Need More Clarity.
            </motion.span>
          </h1>

          <motion.p
            className="hero-description"
            variants={smoothCenterReveal}
          >
            Help your child understand their strengths, interests and possibilities
            before making important education and career decisions.
          </motion.p>

          <motion.div variants={buttonVariants}>
            <a href="#expertise" className="hero-cta-btn">
             Book a Free 45-Minute Consultation
            </a>
          </motion.div>
        </motion.div>

        {/* Right Column: Original Portrait Image Animation & Floating Badge */}
        <div className="hero-person-container">
          <motion.img
            initial={{ opacity: 0, scale: 0.94, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{
              duration: 1.1,
              ease: [0.25, 1, 0.5, 1],
              delay: 0.1,
            }}
            src="/images/Home/Hero.png"
            alt="V. Swaminathan"
            className="hero-cutout-img"
          />

          {/* Top-Right Floating Badge */}
          <motion.div
            className="float-card-name"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
              y: [0, -10, 0] 
            }}
            transition={{
              opacity: { duration: 0.8, delay: 0.4 },
              scale: { duration: 0.8, delay: 0.4 },
              y: {
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut',
              }
            }}
          >
            <h4>V. Swaminathan</h4>
            <p>Founder</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;